import { GridActionsCellItem, GridActionsCellItemProps } from '@mui/x-data-grid-premium';
import React, { RefAttributes } from 'react';
import { useNavigate } from 'react-router-dom';
import { FakeLink } from './FakeLink';

type GridLinkActionProps = { href: string } & GridActionsCellItemProps & RefAttributes<HTMLButtonElement>;

export const GridActionsCellItemLink = ({ href, showInMenu, sx, onClick, ...props }: GridLinkActionProps) => {
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    navigate(href);
    if (onClick) {
      // Type assertion needed due to MUI's complex event type requirements
      onClick(event as React.MouseEvent<HTMLButtonElement> & React.MouseEvent<HTMLLIElement>);
    }
  };

  const menuItemSx = showInMenu
    ? {
        width: '100%',
        minWidth: '100%',
        justifyContent: 'flex-start',
        '& .MuiButtonBase-root': {
          width: '100%',
          justifyContent: 'flex-start',
        },
        ...sx,
      }
    : sx;

  return (
    <FakeLink
      href={href}
      style={
        showInMenu
          ? {
              width: '100%',
              display: 'block',
            }
          : undefined
      }
    >
      <GridActionsCellItem {...(props as any)} showInMenu={showInMenu as any} onClick={handleClick} sx={menuItemSx} />
    </FakeLink>
  );
};
